import React, { useContext, useEffect, useState } from "react";
import "./ExamCreator.css";
import { AnimatePresence, motion } from "framer-motion";
import ExamCreatorSidebar from "./ExamCreatorSidebar/ExamCreatorSidebar";
// import ConfirmationPopup from '../Util/ConfirmationPopup/ConfirmationPopup'
import ViewCaseDetailsPopup from "./ViewCaseDetailsPopup/ViewCaseDetailsPopup";
import CaseListIntro from "./CaseListIntro/CaseListIntro";
import { AppContext } from "../../Util/contexts/AppContext";
import ExamList from "./Components/ExamList";
import SectionList from "./Components/SectionList";
import { ExamCreatorContext } from "../../Util/contexts/ExamCreatorContext";
import {
  backdropMotionProps,
  leftHandDrawerMotionProps,
} from "../../Util/animations/Animations_v2";
import addSectionsToExamArray from "../../Util/functions/ExamCreatorHelperFunctions/addSectionsToExamArray";
import NavigationHeader from "./Components/NavigationHeader";
import CaseListFooter from "./Components/CaseListFooter";
import IncompleteExamList from "./Components/IncompleteExamList";
const ExamCreator = ({
  showSubscriptionEndWarning,
  subscriptionDaysRemaining,
  accentSelected,
  handleSelectAccent,
  updateCaseName,
  setPreviousCompletionsData,
  setPreviousPage,
}) => {
  const {
    userData,
    selectedTheme,
    premadeExams,
    examSections,
    customExams,
    setPremadeExams,
    setCustomExams,
    setExamSections,
    route,
    displayAuthenticationError,
    refreshCaseListOnNextLoad,
    setRefreshCaseListOnNextLoad,
    setReviewLaterExams,
    setReviewLaterSections,
  } = useContext(AppContext);
  const [isCaseDetailsPopupDisplayed, setIsCaseDetailsPopupDisplayed] =
    useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([
    "Listening",
    "Reading",
    "Writing",
    "Speaking",
  ]);
  const [sortBy, setSortBy] = useState("CaseNumber");
  const [isCaseListAscending, setIsCaseListAscending] = useState(true);
  const [isHideCompletedChecked, setIsHideCompletedChecked] = useState(false);
  const [isHideIncompleteChecked, setIsHideIncompleteChecked] = useState(false);
  const [examListView, setExamListView] = useState("Premade Exams"); // Premade Exams, Exam Sections, Custom Exams, Incomplete
  const [caseDetails, setCaseDetails] = useState(null);
  const [loadingExamList, setLoadingExamList] = useState(true);
  const [selectedSectionIds, setSelectedSectionIds] = useState([]);
  const [selectedExamId, setSelectedExamId] = useState(null);
  const [incompleteExams, setIncompleteExams] = useState([]);

  const handleSelectSection = ({ sectionId }) => {
    if (selectedSectionIds.includes(sectionId)) {
      const newSectionIds = selectedSectionIds.filter((id) => id !== sectionId);
      setSelectedSectionIds(newSectionIds);
    } else {
      setSelectedSectionIds([...selectedSectionIds, sectionId]);
    }
  };

  const renderExamView = () => {
    switch (examListView) {
      case "Exam Sections":
        return (
          <SectionList
            key="Sections List"
            selectedSectionIds={selectedSectionIds}
            handleSelectSection={handleSelectSection}
          />
        );

      case "Premade Exams":
        return (
          <ExamList
            key="Premade Exam List"
            selectedExamId={selectedExamId}
            setSelectedExamId={setSelectedExamId}
            childKey="Premade Exam List"
          />
        );

      case "Custom Exams":
        return (
          <ExamList
            key="Custom Exam List"
            selectedExamId={selectedExamId}
            setSelectedExamId={setSelectedExamId}
            childKey="Custom Exam List"
          />
        );

      case "Incomplete":
        return (
          <IncompleteExamList
            key="Incomplete Exam List"
            selectedExamId={selectedExamId}
            setSelectedExamId={setSelectedExamId}
          />
        );

      default:
        return (
          <ExamList
            key="Default Exam List"
            selectedExamId={selectedExamId}
            setSelectedExamId={setSelectedExamId}
            childKey="Default Exam List"
          />
        );
    }
  };
  const { AnimationsDisabled, Profession, Token } = userData;

  useEffect(() => {
    const fetchExamList = async () => {
      const examListData = await fetch(`${route}/listsections.webapi`, {
        method: "GET",
        headers: {
          Token: Token,
          "Content-Type": "text/plain",
        },
      })
        .then(async (response) => {
          if (response.ok) {
            return response.json();
          } else if (response.status === 401) {
            return displayAuthenticationError();
          } else {
            throw new Error(await response.text());
          }
        })
        .then((result) => {
          return result;
        })
        .catch((error) => {});
      console.log(examListData);
      examListData.PreviousCustomExams = examListData.PreviousCustomExams || [];

      for (let i = 0; i < examListData.PremadeExams.length; i++) {
        examListData.PremadeExams[i].examNumber = i + 1;
      }
      for (let i = 0; i < examListData.PreviousCustomExams.length; i++) {
        examListData.PreviousCustomExams[i].examNumber = i + 1;
      }
      for (let i = 0; i < examListData.ExamSections.length; i++) {
        examListData.ExamSections[i].sectionNumber = i + 1;
      }

      if (!examListData.sections) {
        addSectionsToExamArray(
          examListData.PremadeExams,
          examListData.ExamSections,
          examListData.PreviousCustomExams
        );
      }

      const incomplete = [
        ...examListData.PremadeExams,
        ...examListData.PreviousCustomExams,
      ]
        .filter(
          (exam) =>
            exam.IncompleteAttempts && exam.IncompleteAttempts.length > 0
        )
        .sort((a, b) => {
          // Get the most recent TimeAttempted from IncompleteAttempts
          const mostRecentA = a.IncompleteAttempts.reduce((latest, attempt) =>
            new Date(attempt.TimeAttempted) > new Date(latest.TimeAttempted)
              ? attempt
              : latest
          ).TimeAttempted;
          const mostRecentB = b.IncompleteAttempts.reduce((latest, attempt) =>
            new Date(attempt.TimeAttempted) > new Date(latest.TimeAttempted)
              ? attempt
              : latest
          ).TimeAttempted;

          // Sort in descending order (most recent first)
          return new Date(mostRecentB) - new Date(mostRecentA);
        });

      console.log(incomplete);

      setPremadeExams(examListData.PremadeExams);
      setExamSections(examListData.ExamSections);
      setRefreshCaseListOnNextLoad(false);
      setCustomExams(examListData.PreviousCustomExams);
      setIncompleteExams(incomplete);
      setLoadingExamList(false);

      setReviewLaterExams(
        examListData.ReviewLaterExams.examIds.reduce((acc, examId) => {
          acc[examId] = true;
          return acc;
        }, {})
      );
      setReviewLaterSections(
        examListData.ReviewLaterExams.sectionIds.reduce((acc, sectionId) => {
          acc[sectionId] = true;
          return acc;
        }, {})
      );

      const previousCompletions = {
        sections: {},
        exams: {},
      };

      const getExamTitleFromExamId = (examId) => {
        const exam = examListData.PremadeExams.find(
          (exam) => exam.ExamId === examId
        );
        if (exam) {
          return exam.ExamTitle;
        }
        const customExam = examListData.PreviousCustomExams.find(
          (exam) => exam.ExamId === examId
        );
        if (customExam) {
          return customExam.ExamName;
        }
        return null;
      };

      examListData.ExamSections.forEach((section) => {
        if (section.Completed) {
          previousCompletions.sections[section.sectionId] =
            section.secCompletion.map((completion) => {
              return {
                date: completion.TimeAttempted,
                score: completion.GradeForSection,
                guid: completion.guid,
                // examForCompletion will contain the examId and examTitle
                examForCompletion: {
                  examId: completion.ExamId,
                  examTitle: getExamTitleFromExamId(completion.ExamId),
                },
                sectionId: section.SectionId,
              };
            });
        }
      });

      examListData.PremadeExams.forEach((exam) => {
        if (exam.Completed) {
          previousCompletions.exams[exam.ExamId] = exam.completedAttempts.map(
            (completion) => {
              return {
                date: completion.TimeAttempted,
                score: completion.GradeForExam,
                guid: completion.guid,
                examId: exam.ExamId,
                sections: exam.sections.map((section) => {
                  return {
                    category: section.sectionCategory,
                    title: section.sectionTitle,
                    sectionId: section.sectionId,
                    score: section.secCompletion.find((sectionCompletion) => {
                      return sectionCompletion.guid === completion.guid;
                    })?.GradeForSection,
                  };
                }),
              };
            }
          );
        }
      });

      examListData.PreviousCustomExams.forEach((exam) => {
        if (exam.Completed) {
          previousCompletions.exams[exam.ExamId] = exam.completedAttempts.map(
            (completion) => {
              return {
                date: completion.TimeAttempted,
                score: completion.GradeForExam,
                guid: completion.guid,
                examId: exam.ExamId,
                sections: exam.sections.map((section) => {
                  return {
                    category: section.sectionCategory,
                    title: section.sectionTitle,
                    sectionId: section.sectionId,
                    score: section.secCompletion.find((sectionCompletion) => {
                      return sectionCompletion.guid === completion.guid;
                    })?.GradeForSection,
                  };
                }),
              };
            }
          );
        }
      });

      setPreviousCompletionsData(previousCompletions);
    };

    if (
      (premadeExams.length === 0 &&
        customExams.length === 0 &&
        examSections.length === 0) ||
      refreshCaseListOnNextLoad
    ) {
      fetchExamList();
    } else {
      setLoadingExamList(false);
    }
    setPreviousPage(null);
  }, [
    premadeExams,
    customExams,
    examSections,
    Profession,
    setPremadeExams,
    setExamSections,
    setCustomExams,
    route,
    Token,
    displayAuthenticationError,
    refreshCaseListOnNextLoad,
    setRefreshCaseListOnNextLoad,
    setReviewLaterExams,
    setReviewLaterSections,
    setPreviousCompletionsData,
    setPreviousPage,
  ]);

  useEffect(() => {
    if (!isCaseDetailsPopupDisplayed) setCaseDetails(null);
  }, [isCaseDetailsPopupDisplayed]);

  useEffect(() => {
    var metaThemeColor = document.querySelector("meta[name=theme-color]");
    metaThemeColor.setAttribute(
      "content",
      selectedTheme.primaryBackgroundColor
    );
  }, [selectedTheme.primaryBackgroundColor]);

  useEffect(() => {
    setSelectedExamId(null);
    setSelectedSectionIds([]);
  }, [examListView]);

  const handleRandomClick = () => {
    if (examListView === "Exam Sections") {
      setSelectedSectionIds([]);
      const randomSectionIds = [];
      const sectionCount = examSections.length;
      const randomSectionCount = Math.min(8, Math.floor(sectionCount * 0.7));
      for (let i = 0; i < randomSectionCount; i++) {
        const randomIndex = Math.floor(Math.random() * sectionCount);
        if (randomSectionIds.includes(examSections[randomIndex].sectionId)) {
          i--;
          continue;
        }
        randomSectionIds.push(examSections[randomIndex].sectionId);
      }
      setSelectedSectionIds(randomSectionIds);
    } else {
      // Handle all exam list types (Premade, Custom, Incomplete, etc.)
      let exams;
      switch (examListView) {
        case "Premade Exams":
          exams = premadeExams;
          break;
        case "Custom Exams":
          exams = customExams;
          break;
        case "Incomplete":
          exams = incompleteExams;
          break;
        default:
          exams = premadeExams;
      }

      if (exams.length > 0) {
        const randomIndex = Math.floor(Math.random() * exams.length);
        setSelectedExamId(exams[randomIndex].ExamId);
        document
          .getElementById(`exam-${exams[randomIndex].ExamId}`)
          ?.scrollIntoView({
            behavior: AnimationsDisabled ? "auto" : "smooth",
            block: "center",
          });
      }
    }
  };

  return (
    <ExamCreatorContext.Provider
      value={{
        sortBy: sortBy,
        setSortBy: setSortBy,
        isCaseListAscending: isCaseListAscending,
        setIsCaseListAscending: setIsCaseListAscending,
        isHideCompletedChecked: isHideCompletedChecked,
        setIsHideCompletedChecked: setIsHideCompletedChecked,
        isHideIncompleteChecked: isHideIncompleteChecked,
        setIsHideIncompleteChecked: setIsHideIncompleteChecked,
        searchTerm: searchTerm,
        setSearchTerm: setSearchTerm,
        selectedCategories: selectedCategories,
        setSelectedCategories: setSelectedCategories,
        examListView: examListView,
        setExamListView: setExamListView,
        setIsMobileDrawerOpen: setIsMobileDrawerOpen,
        setCaseDetails: setCaseDetails,
        setIsCaseDetailsPopupDisplayed: setIsCaseDetailsPopupDisplayed,
        loadingExamList: loadingExamList,
        incompleteExams: incompleteExams,
      }}
    >
      <div className="caseListPageContainer">
        <div className="caseListSidebarWrapper">
          <ExamCreatorSidebar
            showSubscriptionEndWarning={showSubscriptionEndWarning}
            subscriptionDaysRemaining={subscriptionDaysRemaining}
            accentSelected={accentSelected}
            handleSelectAccent={handleSelectAccent}
            AnimationsDisabled={AnimationsDisabled}
          />
        </div>
        <AnimatePresence mode="wait">
          {Profession === "" ? (
            <CaseListIntro
              setIsExamStylePremade={(value) =>
                setExamListView(value ? "Premade Exams" : "Custom Exams")
              }
              closeIntro={() => null}
              key="Case List Intro"
            />
          ) : (
            <div
              className="caseListBodyPageWrapper"
              key="caseListBodyPageWrapper"
              id="caseListBodyPageWrapper"
            >
              <NavigationHeader />
              <AnimatePresence mode="wait">{renderExamView()}</AnimatePresence>
              <CaseListFooter
                selectedSectionIds={selectedSectionIds}
                handleRandomClick={handleRandomClick}
                selectedExamId={selectedExamId}
              />
            </div>
          )}
        </AnimatePresence>
        <AnimatePresence>
          {isMobileDrawerOpen && (
            <div
              className="caseListMobileDrawerPageContainer"
              key="caseListMobileDrawer"
            >
              <motion.div
                className="caseListMobileDrawerBackdrop"
                key="caseListMobileNavBackdrop"
                {...backdropMotionProps(AnimationsDisabled)}
                onClick={() => setIsMobileDrawerOpen(false)}
              />
              <motion.div
                className="caseListMobileDrawerContainer"
                key="caseListMobileDrawerContainer"
                {...leftHandDrawerMotionProps(AnimationsDisabled)}
              >
                <ExamCreatorSidebar
                  showSubscriptionEndWarning={showSubscriptionEndWarning}
                  subscriptionDaysRemaining={subscriptionDaysRemaining}
                  accentSelected={accentSelected}
                  handleSelectAccent={handleSelectAccent}
                />
              </motion.div>
            </div>
          )}
        </AnimatePresence>
        <AnimatePresence>
          {isCaseDetailsPopupDisplayed && (
            <ViewCaseDetailsPopup
              caseData={caseDetails}
              closePopup={() => setIsCaseDetailsPopupDisplayed(false)}
              updateCaseName={updateCaseName}
            />
          )}
        </AnimatePresence>
      </div>
    </ExamCreatorContext.Provider>
  );
};

export default ExamCreator;
